import Vue from 'vue';
export default Vue.extend({
    name: 'multiAssetTogglerPopupChunk',
    props: {
        slotData: {
            required: true
        }
    }
});
